import script from "./PaymentStatusDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusDialog.vue?vue&type=style&index=0&id=3b6298d6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6298d6"]])

export default __exports__